import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getRoleList = () => axiosInstance.get(API_ENDPOINTS.getRoleList);

export const getRoleEntity = (id: number) =>
  axiosInstance.get(API_ENDPOINTS.getRoleEntity(id));

export const createRole = (payload: any) =>
  axiosInstance.post(API_ENDPOINTS.createRole, payload);

export const updateRole = (payload: any) =>
  axiosInstance.put(API_ENDPOINTS.updateRole, payload);

export const deleteRole = (id: number) =>
  axiosInstance.delete(API_ENDPOINTS.deleteRole(id));

export const assignPermissions = (payload: { roleId: number; permissionIds: number[] }) =>
  axiosInstance.put(API_ENDPOINTS.assignPermissions, payload);
